import { utils } from '@hh/global.js'
const { addToCart, reRenderShopifySections } = utils

const waitForWishlist = () =>
  new Promise((resolve, reject) => {
    const startTimeout = Date.now()
    const timeoutLimit = 5000
    const wishlistInterval = setInterval(() => {
      const wishlistForms = document.querySelectorAll(
        'form[data-wishlist-item-id]'
      )
      if (window.WishlistKing !== null && wishlistForms.length > 0) {
        clearInterval(wishlistInterval)
        resolve(wishlistForms)
      } else if (Date.now() - startTimeout > timeoutLimit) {
        clearInterval(wishlistInterval)
        reject(new Error('Timeout Waiting for WishlistKing'))
      }
    }, 250)
  })

const wishlistSubmit = async (event) => {
  event.preventDefault()
  event.stopPropagation()
  const form = event.target

  const data = await addToCart({
    form_type: 'product',
    id: new FormData(form).get('id'),
    quantity: 1,
  })

  reRenderShopifySections(data)

  utils.toggle(document.body, ['mini-cart-is-active'])

  window.WishlistKing.removeWishlistItem({
    wishlistItemId: form.dataset.wishlistItemId,
  })
}

;(async () => {
  try {
    const wishlistForms = await waitForWishlist()
    wishlistForms.forEach((form) => {
      form.addEventListener('submit', wishlistSubmit)
    })
  } catch (err) {
    console.error(err)
  }
})()
